'use strict';
var wellKnownSymbol = require('../internals/well-known-symbol');

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/to-string-tag-support.js
// module id = 179
// module chunks = 13